import { create_UUID } from "common";
import type { FieldDefinition, SchemaDocument } from "model/CustomFields";
import { startDraft } from "./schemaDraft";

/** The engine binds this temporary identity to the model it creates atomically. */
export function newModelSchemaCommand(fields: readonly FieldDefinition[], candidateBpmnXml: string) {
  const operationId = create_UUID();
  const schema: SchemaDocument = {
    contractVersion: 1,
    modelId: operationId,
    schemaRevision: 0,
    policyRevision: 0,
    fields: startDraft(fields),
  };
  return {
    operationId,
    instanceHandle: operationId,
    expectedRevision: { schema: 0, policy: 0 },
    schemaChange: {
      schema,
      candidateBpmnXml,
      reconciliation: "next_save_or_transition" as const,
    },
  };
}
